import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined, DashOutlined } from '@ant-design/icons';
import { ArrowDropDownSharp, ArrowDropUpSharp } from '@mui/icons-material';
/**
 * PnL Component to render profit and loss with color coding and optional multiplier.
 *
 * @param {Object} props - The component props.
 * @param {number} props.value - The value to be formatted.
 * @param {number} [props.multiplier=100] - Optional multiplier for the value.
 * @param {number} [props.precision=1] - Optional precision for formatting.
 * @returns React.Node
 */
const PnL = ({ value, multiplier = 100, precision = 1, theme='light', fontSize }) => {
  // Apply multiplier and format the value
  value = parseFloat(value);
  const formattedValue = Math.abs((value * multiplier).toFixed(precision));
  // Determine the color and arrow based on the value
  let color = value > 0 ? '#0ca232' : '#d60505';
  let ArrowIcon = value > 0 ? ArrowDropUpSharp : ArrowDropDownSharp;
  if (value===0){
    ArrowIcon = DashOutlined;
    color = '#aaccff'
  }
  return (
    <span style={{ color: '#000', fontSize }}>
      <ArrowIcon style={{ marginRight: 5, color }} />
      {formattedValue}%
    </span>
  );
};

export default PnL;
